var React = require('react');

function TransferArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.5"},[React.createElement("path",{"d":"M14 3v4h-4","key":0}),React.createElement("path",{"d":"M1.597 5.666c.656-1.78 2.218-3.113 4.136-3.53 1.918-.417 3.924.14 5.314 1.476L14 6.277","key":1})]));
}

TransferArrow.defaultProps = {"width":"16","height":"9","viewBox":"0 0 16 9"};

module.exports = TransferArrow;

TransferArrow.default = TransferArrow;
